<p>
  Designates what creatures to affect.
  <avr-autodoc-link anchor="target"></avr-autodoc-link>
</p>

<div fxLayout="row" fxLayoutGap="6px" class="auto-row">
  <mat-form-field>
    <mat-label>Target</mat-label>
    <mat-select [(value)]="selectedTarget" (selectionChange)="onTargetSelectChange($event)">
      <mat-option value="all" *ngIf="!context.isIEffectButton">All</mat-option>
      <mat-option value="self">Caster</mat-option>
      <mat-option value="position" *ngIf="!context.isIEffectButton">Position</mat-option>
      <mat-option value="parent" *ngIf="context.isIEffect">Parent</mat-option>
      <mat-option value="children" *ngIf="context.isIEffect">Children</mat-option>
      <!-- this value is deprecated, but it still needs to exist here -->
      <mat-option value="each" style="height: 0;">All</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- target position -->
  <mat-form-field *ngIf="isNumber(effect.target)">
    <input matInput
           placeholder="Target Position"
           type="number"
           min="1"
           [value]="effect.target.toString()"
           (change)="onTargetPosChange(targetPosInput)"
           #targetPosInput>
  </mat-form-field>

  <!-- target sorting -->
  <mat-form-field *ngIf="effect.target !== 'self'"
                  matTooltip="By default, targets are processed in the order the -t arguments are given.">
    <mat-label>Sort Targets By</mat-label>
    <mat-select [(value)]="selectedTargetSort" (selectionChange)="onTargetSortChange($event)">
      <mat-option value="user">User Input</mat-option>
      <mat-option value="hp_asc">HP Ascending</mat-option>
      <mat-option value="hp_desc">HP Descending</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<p>
  Use the Effect Tree to edit the child effects!
</p>
